import styled from 'styled-components'

export const CategoriesContainer = styled.div`
  width: 100%;
  background-color: #0a0a0a;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`

export const MainSection = styled.div`
  padding: 40px 20px;
  @media (min-width: 768px) {
    padding: 40px 40px;
  }
  position: relative;
  background-color: #0a0a0a;
`

export const ContentGrid = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 30px;
  }
`

export const LeftCol = styled.div`
  flex: 1;
  max-width: 600px;
  @media (max-width: 900px) {
    margin-left: 0;
    width: 100%;
  }
`

export const RightCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 1;

  @media (max-width: 900px) {
    align-items: center;
    width: 100%;
  }
`

export const MainTitle = styled.h1`
  color: #00cfff;
  font-style: italic;
  font-size: 3rem;
  font-weight: 800;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 2px;
  line-height: 1.1;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 1.8rem;
    text-align: left;
    letter-spacing: 1px;
  }
`

export const SearchWrap = styled.div`
  display: flex;
  align-items: center;
  background-color: #0a0a0a;
  border: 1px solid #fff000;
  box-shadow: 0 0 10px rgba(255,240,0,0.8), 0 0 20px rgba(255,240,0,0.4);
  border-radius: 50px;
  padding: 5px 20px;
  width: 100%;
  max-width: 500px;
  cursor: pointer;
  box-sizing: border-box;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    padding: 3px 15px;
    max-width: 100%;
    margin: 0 0 20px 0;
  }
`

export const SearchInput = styled.input`
  background: transparent;
  border: none;
  color: #fff;
  font-size: 1rem;
  flex: 1;
  width: 0; /* Important for flex-grow to work without pushing out siblings */
  outline: none;
  padding: 10px 0;

  &::placeholder {
    color: #888;
  }

  @media (max-width: 768px) {
    font-size: 0.85rem;
    padding: 8px 0;
  }
`

export const SearchIconBtn = styled.div`
  color: #fff000;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  padding-left: 10px;
  cursor: pointer;
  flex-shrink: 0;
`

export const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  width: 100%;
  max-width: 500px;

  @media (max-width: 900px) {
    max-width: 100%;
  }
`

export const CategoryButton = styled.div`
  height: 60px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Anton', sans-serif;
  font-style: italic;
  font-size: 1.1rem;
  color: #fff;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.2s;
  background-color: #0a0a0a;
  text-align: center;
  padding: 0 15px;

  border: 3px solid ${props => props.color === 'pink' ? '#fc0a7e' : '#00e5ff'};
  box-shadow: 0 0 10px ${props => props.color === 'pink' ? 'rgba(252, 10, 126, 0.6)' : 'rgba(0, 229, 255, 0.6)'};

  &:hover {
    transform: scale(1.05);
    background-color: #1a1a1a;
  }

  svg {
    font-size: 2rem;
    color: ${props => props.iconColor ? `${props.iconColor} !important` : (props.color === 'pink' ? '#fc0a7e !important' : '#00e5ff !important')};
    fill: ${props => props.iconColor ? `${props.iconColor} !important` : (props.color === 'pink' ? '#fc0a7e !important' : '#00e5ff !important')};

    path, circle, rect, polygon, polyline, ellipse {
      fill: currentColor !important;
      stroke: ${props => props.iconColor ? `${props.iconColor} !important` : 'transparent !important'};
    }
  }

  @media (max-width: 768px) {
    height: 50px;
    font-size: 0.9rem;
    border-width: 2px;
  }
`

export const BottomBar = styled.div`
  width: calc(100% - 40px);
  margin: 0 20px 40px 20px;
  @media (min-width: 768px) {
    width: calc(100% - 80px);
    margin: 0 40px 40px 40px;
  }
  background-color: #0056ff;
  padding: 10px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  border-radius: 50px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 15px;
    text-align: center;
    border-radius: 25px;
    padding: 20px 15px;
    width: 90%;
    align-self: center;
    border-radius: 20px;
  }
`

export const BottomText = styled.h2`
  color: #fff;
  font-style: italic;
  font-weight: bold;
  margin: 0;
  font-size: 1.5rem;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`

export const BottomBtn = styled.button`
  background-color: #fff000;
  color: #0a0a0a;
  border: none;
  padding: 12px 30px;
  font-weight: bold;
  border-radius: 50px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 10px 20px;
  }
`
